import {Component} from '@angular/core';
import {OAuthService, JwksValidationHandler} from 'angular-oauth2-oidc';
import {AuthConfig} from 'angular-oauth2-oidc';

@Component({selector: 'app-base-root', templateUrl: './app-base.component.html'})
export class AppBaseComponent {
  title = 'app';
}